import React from 'react';

import type { AvailableIconName } from '@/assets/icons';
import { Stack } from '@/components/layout';
import { SvgIcon, Switch, Text } from '@/components/ui';
import { createStyles, useScaling } from '@/hooks';
import { colors, guardianColors } from '@/theme/colors';

type BiometricRowProps = {
  icon: AvailableIconName;
  title: string;
  subtitle: string;
  value: boolean;
  disabled: boolean;
  onValueChange: (value: boolean) => void;
};

export function BiometricRow({
  icon,
  title,
  subtitle,
  value,
  disabled,
  onValueChange,
}: BiometricRowProps) {
  const { scale } = useScaling();
  const styles = useStyles();

  return (
    <Stack direction="row" align="center" style={styles.card}>
      <Stack style={styles.iconTile}>
        <SvgIcon name={icon} size={scale(20)} color={guardianColors['Main/Main']} />
      </Stack>
      <Stack flex={1} paddingRight={scale(8)}>
        <Text variant="Font Guardian App/Subtitle/Subtitle 14 Bold" style={styles.title}>
          {title}
        </Text>
        <Text
          variant="Font Guardian App/Subtitle/Subtitle 11 Regular"
          style={styles.subtitle}
          numberOfLines={2}>
          {subtitle}
        </Text>
      </Stack>
      <Switch value={value} disabled={disabled} onValueChange={onValueChange} />
    </Stack>
  );
}

const useStyles = createStyles(({ scale }) => ({
  card: {
    borderRadius: scale(12),
    borderCurve: 'continuous',
    backgroundColor: colors['0'],
    paddingVertical: scale(10),
    paddingRight: scale(16),
    paddingLeft: scale(12),
    gap: scale(10),
    shadowColor: '#222B45',
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0.04,
    shadowRadius: scale(8),
    elevation: 1,
  },
  iconTile: {
    width: scale(40),
    height: scale(40),
    borderRadius: scale(8),
    borderCurve: 'continuous',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: guardianColors['Main/10'],
  },
  title: {
    color: guardianColors['Main/Main'],
  },
  subtitle: {
    color: guardianColors['6'],
  },
}));
